export const LISTE_PERIODICITE = {
  title: 'Liste des périodicités',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste périodicités',
  },
  actions: {
    add: 'Ajouter une périodicité',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
    archiver: 'Archiver',
  },
  tab: {
    libelle: 'Libellé',
    codification: 'Code',
    nbJour: 'Nombre de jours',
    nbMois: 'Nombre de mois',
  },
  yes: 'Oui',
  no: 'Non',
};

export const ADD_PERIODICITE = {
  titleAdd: 'Ajouter une périodicité',
  titleEdit: 'Modifier une périodicité',
  actions: {
    cancel: 'Annuler',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
  },
  informationPeriodicite: {
    libelle: 'Libellé',
    codification: 'Code',
    nbJour: 'Nombre de jours',
    nbMois: 'Nombre de mois',
  },
  success: {
    add: 'La périodicité a été ajouté avec succès.',
    edit: 'Le périodicité a été modifié avec succès.',
  },
};
